
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/users",
      function () {
        return require("private-next-pages/admin/users/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/users"])
      });
    }
  